import { ShellRoutesGroupConfig } from './routesComposition';

export default class ShellPublicRoutes implements ShellRoutesGroupConfig {
    constructor(public routes: Array<DurandalRouteConfiguration>) { }
}